import { debounce } from "./utilities/debounce";

window.customElements.define(
    "customer-application",
    class extends HTMLElement {
        private readonly collapseToggle: HTMLButtonElement | null;
        private readonly removeAnimatedClassesFunction: (...args: any) => void;
        private readonly hamburgerToggle: HTMLButtonElement | null;
        private readonly inertableElements: NodeListOf<Element>;
        private readonly sidebarNavigation: Element | null;

        constructor() {
            super();

            this.collapseToggle = this.querySelector("button[data-customer-application-collapse-toggle]");
            this.removeAnimatedClassesFunction = debounce(() => this.classList.remove("customer-application--is-animated"), 750);
            this.hamburgerToggle = this.querySelector("button[data-customer-application-hamburger-toggle]");
            this.inertableElements = this.querySelectorAll("[data-customer-application-inertable]");
            this.sidebarNavigation = this.querySelector("[data-customer-application-sidebar-navigation]");
        }

        connectedCallback() {
            if (document.documentElement.getAttribute("data-customer-application-collapsed") === "true") {
                this.collapseToggle?.setAttribute("aria-pressed", "true");
            }

            if (this.isUsingOffscreenMenu() && (this.getAttribute("show-offscreen-menu") === "false")) {
                this.sidebarNavigation?.setAttribute("inert", "inert");
            }

            this.collapseToggle?.addEventListener(
                "click",
                (event) => {
                    this.classList.add("customer-application--is-animated");
                    this.removeAnimatedClassesFunction();

                    if (document.documentElement.hasAttribute("data-customer-application-collapsed")) {
                        this.collapseToggle?.setAttribute("aria-pressed", "false");
                        localStorage.removeItem("myae-sidebar");
                        document.documentElement.removeAttribute("data-customer-application-collapsed");
                    } else {
                        this.collapseToggle?.setAttribute("aria-pressed", "true");

                        localStorage.setItem("myae-sidebar", "collapsed");
                        document.documentElement.setAttribute("data-customer-application-collapsed", "true");
                    }
                },
            );

            this.hamburgerToggle?.addEventListener(
                "click",
                (event) => {
                    this.classList.add("customer-application--is-animated");
                    debounce(this.removeAnimatedClassesFunction, 750)();

                    if (this.getAttribute("show-offscreen-menu") === "false") {
                        this.setAttribute("show-offscreen-menu", "true");

                        this.inertableElements?.forEach((el) => el.setAttribute("inert", "inert"));
                        this.sidebarNavigation?.removeAttribute("inert");
                    } else {
                        this.setAttribute("show-offscreen-menu", "false");

                        this.inertableElements?.forEach((el) => el.removeAttribute("inert"));
                        this.sidebarNavigation?.setAttribute("inert", "inert");
                    }
                },
            )

            const resizeObserver = new ResizeObserver(
                (entries) => {
                    if (!this.isUsingOffscreenMenu()) {
                        this.inertableElements?.forEach((el) => el.removeAttribute("inert"));
                        this.sidebarNavigation?.removeAttribute("inert");
                    } else {
                        if (this.getAttribute("show-offscreen-menu") === "true") {
                            this.inertableElements?.forEach((el) => el.setAttribute("inert", "inert"));
                            this.sidebarNavigation?.removeAttribute("inert");
                        } else {
                            this.inertableElements?.forEach((el) => el.removeAttribute("inert"));
                            this.sidebarNavigation?.setAttribute("inert", "inert");
                        }
                    }
                },
            );

            resizeObserver.observe(this);
        }

        private isUsingOffscreenMenu(): boolean {
            return window.getComputedStyle(this).getPropertyValue('--customer-application-is-using-offscreen-menu') === "1";
        }
    },
);
